import styled from 'styled-components';

// import Bg from "../../assets/landingPage/Grupo3493.png";

export const Home = styled.div`
  width: calc(100% - 90px);
  height: calc(100% - 90px);
  position: fixed;
  background: #f6f6f9;
  z-index: 9999999999999;
  padding: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    width: calc(100% - 50px);
    height: calc(100% - 25px);
    padding: 25px;
    align-items: center;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1024px;
  position: relative;

  .shapes {
    position: absolute;
    left: 25px;
  }
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Logos = styled.div`
  float: left;
  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    img {
      &:last-child {
        margin-top: 8px;
        width: 50%;
      }
    }
    @media (max-width: 768px) {
      align-items: center;
      margin-bottom: 24px;
    }
  }
`;

export const AppStore = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ primaryColor }) => primaryColor ?? '#1d3054'};

  .stores {
    display: flex;
    gap: 24px;

    flex-direction: row;
    flex-wrap: wrap;
    max-width: fit-content;

    svg {
      height: 35px;
      width: auto;

      path {
        fill: ${({ primaryColor }) => primaryColor ?? '#1d3054'};
      }
    }
  }
  .title {
    text-align: right;
    color: #848484;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  a {
    width: max-content;
    text-decoration: none;
  }
  @media (max-width: 768px) {
    margin-bottom: 16px;
    .title {
      text-align: center;
    }

    svg {
      height: 29px;
    }
  }
`;

export const Store = styled.div`
  display: flex;
  color: #1d3054;
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;

  span {
    color: ${({ primaryColor }) => primaryColor ?? '#1d3054'};
    display: flex;
    flex-direction: column;
    small {
      font-size: 14px;

      &:first-child {
        font-size: 8px;
        font-weight: 600;
        margin-bottom: 4px;
      }
      &:last-child {
        font-weight: bold;
      }
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Left = styled.div`
  height: 100%;
  width: 50%;
  .cta {
    position: relative;
    margin-bottom: 80px;
  }
  h1 {
    font-size: 75px;
    color: #1d3054;
    font-weight: bold;
    margin-bottom: 16px;
    margin-top: 0;
    span {
      color: #b61817;
    }
  }
  @media (max-width: 768px) {
    width: 100%;

    h1 {
      font-size: 44px;
      text-align: center;
      margin: 8px 0 36px 0;
    }
    .cta {
      display: flex;
      justify-content: center;
      margin-bottom: 50px;
    }
  }
`;

export const Button = styled.button`
  width: 295px;
  height: 62px;
  border-radius: 32px;
  border: 1px solid #1d3054;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.principal ? '#1D3054' : '#f6f6f9')};
  transition: 0.2s ease-in-out;
  cursor: pointer;

  color: ${(props) => (props.principal ? '#f6f6f9' : '#1D3054')};
  svg {
    fill: ${(props) => (props.principal ? '#f6f6f9' : '#1D3054')};
  }

  &:hover {
    background-color: ${(props) => (props.principal ? '#f6f6f9' : ' #1D3054')};
    color: ${(props) => (props.principal ? '#1D3054' : ' #f6f6f9')};

    svg {
      fill: ${(props) => (props.principal ? '#1D3054' : '#f6f6f9')};
    }
  }
`;

export const MessageFirstAccess = styled.span`
  color: #4d4d4d;
  position: absolute;
  bottom: -24px;
  left: 0;
  font-size: 10px;
  @media (max-width: 768px) {
    left: 40px;
  }
`;

export const AlertMessageFirstAccess = styled.div`
  position: absolute;
  font-size: 10px;
  text-align: left;
  bottom: -85px;
  strong {
    color: #1d3054;

    font-weight: bold;
  }
  .important {
    margin-bottom: 5px;
    display: block;
    color: #b61817;
  }
  p {
    margin: 0;
  }
  .oldPortal {
    margin-top: 15px;
  }
  @media (max-width: 768px) {
    left: 40px;
  }
`;

export const Right = styled(Left)`
  @media (max-width: 768px) {
    display: none;
  }
`;
